<template>
  <div id="wrapper" :class="isEsms ? 'esms' : 'search'">
    <navbar></navbar>
    <div class="super-main-container">
      <AsMenu
        :router="true"
        :defaultActive="defaultActiveMenu"
        :menuConfig="menuConfig"
        :tabList="[SEARCH, ESMS]"
        :activeTab.sync="activeTab"
        height="calc(100vh - 40px)"
      >
      </AsMenu>
      <div class="main-container">
        <zm-scrollbar class="main-app-layout-scrollbar">
          <breadcrumb></breadcrumb>
          <app-main class="appmain-container" />
        </zm-scrollbar>
      </div>

      <Help></Help>
      <div class="empty"></div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Navbar from '@/components/layout/navbar'
// import Sidebar from '@/components/layout/sidebar'
import Breadcrumb from '@/components/layout/breadcrumb'
import AppMain from '@/components/layout/appMain'
import Footer from '@/components/layout/footer'
import menuConfig from '@/components/layout/menu.config.js'
import Help from '@/components/layout/help'
const ESMS = 'ES Manage'
const SEARCH = 'Search'
export default {
  name: 'layout',
  components: {
    Navbar,
    // Sidebar,
    AppMain,
    Breadcrumb,
    Footer,
    Help
  },
  data() {
    return {
      SEARCH,
      ESMS,
      input: '',
      menuConfig: {},
      activeTab: SEARCH,
      menuIndexs: []
    }
  },
  watch: {
    activeTab(v) {
      if (v === ESMS && !this.isEsms) {
        this.defaultActiveMenu = '/esinfo/cluster'
      } else if (v === SEARCH && this.isEsms) {
        this.defaultActiveMenu = '/search/rest/terminal'
      }
    }
  },
  computed: {
    isEsms() {
      return !!this.$route.matched.filter(route => {
        return route.path.includes('/esms') || route.path.includes('/esinfo')
      })?.length
    },
    defaultActiveMenu: {
      get() {
        if (this.menuIndexs.includes(this.$route.path)) {
          return this.$route.path
        } else if (this.$route.matched.length >= 3) {
          const paths = this.$route.path.split('/')
          paths.pop()
          return paths.join('/')
        }
        return this.$route.path
      },
      set(v) {
        this.$router.push(v)
      }
    }
  },
  created() {
    this.getMenuIndexs()
    this.activeTab = this.isEsms ? ESMS : SEARCH
    this.menuConfig[ESMS] = this.filterMenu(menuConfig[ESMS])
    this.menuConfig[SEARCH] = this.filterMenu(menuConfig[SEARCH])
    this.bindRouterEvent()
  },
  methods: {
    filterMenu(menuConfig) {
      const res = menuConfig.reduce((results = [], menu) => {
        if (menu.children) {
          menu.children = this.filterMenu(menu.children)
        }
        if (this.handleConditions(menu)) {
          results.push(menu)
        }
        return results
      }, [])
      return res
    },
    handleConditions(item) {
      if (!item.permission && !item.roles) {
        return true
      }
      if (item.roles) {
        return this.hasAnyRole(item.roles)
      }
      if (item.permission) {
        const { resource, action } = item.permission
        return this.hasPermission(resource, action)
      }
    },
    getMenuIndexs() {
      const menuIndexs = []
      Object.keys(menuConfig).map(menuType => {
        menuIndexs.push(
          ...menuConfig[menuType].map(menu => {
            if (menu.children?.length) {
              menuIndexs.push(
                ...menu.children.map(child => {
                  return child.index
                })
              )
            }
            return menu.index
          })
        )
      })
      this.menuIndexs = menuIndexs
    },
    bindRouterEvent() {
      this.$router.afterEach(() => {
        this.activeTab = this.isEsms ? ESMS : SEARCH
      })
    }
  }
}
</script>
<style lang="scss">
@import '@/styles/common.scss';
// todo expect to be border-box
// .search {
//   * {
//     box-sizing: content-box;
//   }
// }
.as-menu {
  z-index: 1005;
  * {
    box-sizing: border-box;
  }
}
.as-menu .zm-menu .zm-menu-item .zm-tooltip [class^='zm-icon-'] {
  margin-left: -5px;
}
.as-menu {
  .menu-box {
    padding-top: 6px;
  }
  .zm-menu .zm-menu-item.is-active [class^='zm-icon-'],
  .zm-menu .zm-menu-item.is-active [class^='zm-icon-']:before {
    color: #fff;
  }
}
.as-resize-toolbar .collapse-button {
  z-index: 1006;
}
</style>
<style lang="scss" scoped>
.super-main-container {
  height: calc(100% - 72px);
  display: flex;
  position: relative;
}

.main-container {
  flex: 1;
  height: 105%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  padding: 8px 8px 20px 20px;
}
.main-app-layout-scrollbar {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  > :deep(.zm-scrollbar__wrap) {
    overflow-x: hidden;
  }
  > :deep(.zm-scrollbar__bar.is-vertical > div) {
    width: 0;
  }
}
</style>
